<template>
	<div class="doctor-card">
		<div class="doctor-card--header">
			<div class="tag text-center">{{type === 'team'? '绑定医生团队':'绑定医生' }}</div>
		</div>
		<div class="doctor-card--body">
			<div v-if="type === 'team'" class="department_info">
				<p class="hospital_name van-multi-ellipsis--l2">
					{{ teamDetail.hospitalName }}
				</p>
				<h2 class="doctor_name">
					{{ teamDetail.teamName | filterEmptyProps }}
				</h2>
				<p class="hospital_name van-multi-ellipsis--l2">
					{{ doctor.name | filterEmptyProps }} {{ doctor.title | filterEmptyProps }}
				</p>
			</div>
			<div v-else class="content">
				<div class="avatar">
					<img
						v-if="doctor.avatar"
						class="avatar__inner"
						:src="doctor.avatar"
						:alt="doctor.name"
						:title="doctor.name"
					/>
					<img
						v-else
						class="avatar__inner"
						src="@/assets/img/default_avatar.png"
						:alt="doctor.name"
						:title="doctor.name"
					/>
				</div>
				<div class="info">
					<h2 class="doctor_name">
						{{ doctor.name | filterEmptyProps }}
						<span>{{ doctor.title | filterEmptyProps }}</span>
					</h2>
					<p class="hospital_name van-multi-ellipsis--l2">
						{{ doctor.hospitalName }} {{ doctor.departmentName }}
					</p>
				</div>
			</div>
		</div>
		<!-- 团队详情弹窗 -->
		<DepartmentDetailDialog v-model="showTeamDetail" :item="teamDetail" />
		<!-- 医生详情弹窗 -->
		<DoctorDetailDialog v-model="showDoctorDetail" :item="doctor" />
	</div>
</template>

<script>
import DoctorDetailDialog from './doctor-detail-dialog.vue'
import DepartmentDetailDialog from '../../physician-visits/components/department-detail-dialog.vue'
export default {
    name: 'doctor-card',
    components: { DoctorDetailDialog, DepartmentDetailDialog },
    data: () => ({
        loading: false,
        showDoctorDetail: false,
        showTeamDetail: false,
        doctor: {},
        teamDetail: {}
    }),
    filters: {
        filterEmptyProps (val) {
            return val ? val : '--'
        }
    },
    computed: {
        type () {
            return this.$route.params.teamId ? 'team' : ''
        }
    },
    methods: {
        // 获取医生详情
        getDoctorDetail (doctorId) {
            this.loading = true
            this.$api.doctor.getDoctorInfoById(doctorId).then(res => {
                this.loading = false
                if (!res.code) this.doctor = res.data
            }).catch(() => this.loading = false)
        },
        getTeamDetail (item, id) {
            if (item.id) {
                this.teamDetail = item
            } else {
                this.$api.doctor.getTeamDetail(id).then(res => {
                    if (!res.code) this.teamDetail = res.data
                })
            }
        },
        showDialog () {
            if (this.teamDetail.id) {
                this.showTeamDetail = true
            } else {
                this.showDoctorDetail = true
            }
        }
    }
};
</script>

<style scoped lang="less">
.doctor-card {
	min-height: 218px;
	border-radius: 20px;
	background-color: @primary;
	.doctor-card--header {
		.tag {
			display: inline-block;
			width: 176px;
			height: 50px;
			line-height: 50px;
			background-color: mix(#fff, @primary, 60%);
			border-radius: 20px 0;
			color: mix(#000, @primary, 24%);
			font-family: PingFangSC-Medium;
			font-size: 24px;
			font-weight: 500;
		}
	}
	.doctor-card--body {
		padding: 20px;
		.department_info {
			flex: auto;
			padding-left: 24px;
			text-align: center;
			.doctor_name {
				font-family: PingFangSC-Medium;
				font-size: 40px;
				font-weight: 400;
				color: #fff;
				margin: 12px 0;
				& > span {
					font-size: 26px;
					padding-left: 14px;
				}
			}
			.hospital_name {
				font-family: PingFangSC-Regular;
				font-size: 28px;
				font-weight: normal;
				color: #fff;
			}
		}
		.content {
			display: flex;
			align-items: center;
			.avatar {
				flex: 0 0 112px;
				width: 112px;
				height: 112px;
				border-radius: 50%;
				overflow: hidden;
				.avatar__inner {
					width: inherit;
					height: inherit;
					object-fit: cover;
				}
			}
			.info {
				flex: auto;
				padding-left: 24px;
				.doctor_name {
					font-family: PingFangSC-Medium;
					font-size: 38px;
					font-weight: 500;
					color: #fff;
					& > span {
						font-size: 26px;
						padding-left: 14px;
					}
				}
				.hospital_name {
					font-family: PingFangSC-Regular;
					font-size: 24px;
					font-weight: normal;
					color: #fff;
					margin-top: 8px;
				}
			}
		}
	}
}
</style>
